import { Type } from '@sinclair/typebox';

const usageRowSchema = Type.Object({
    month: Type.String(),
    clientCompanyId: Type.String(),
    companyName: Type.Union([Type.String(), Type.Null()]),
    model: Type.String(),
    endpoint: Type.Union([Type.String(), Type.Null()]),
    tokensIn: Type.Number(),
    tokensOut: Type.Number(),
    estimatedCost: Type.Number(),
    callCount: Type.Number(),
});

const pricingRowSchema = Type.Object({
    model: Type.String(),
    inputPerMillion: Type.Number(),
    outputPerMillion: Type.Number(),
});

export const aiUsagePaths = {
    '/api/ai/usage/monthly': {
        get: {
            operationId: 'aiUsageControllers.getMonthlyUsage',
            parameters: [
                {
                    name: 'monthsBack',
                    in: 'query' as const,
                    schema: Type.Optional(Type.String()),
                },
            ],
            responses: {
                '200': {
                    description: 'Monthly token usage grouped by model + endpoint for the current tenant',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                rows: Type.Array(usageRowSchema),
                                pricing: Type.Array(pricingRowSchema),
                            }),
                        },
                    },
                },
            },
        },
    },
} as const;
